import { ProjectType } from "../../../../clients/graphqlTypes.js";

export type MatrixSelection = {
  categoryId: string;
  projectType: ProjectType;
};

export type OnboardingFlowWizardState = {
  selectedVerticals: string[];
  selectedProjectTypes: ProjectType[];
  applyToAll: "unset" | "yes" | "no";
  specifyMode: "unset" | "now" | "later";
  // Matrix-stage row toggle. A category appears here iff the user has
  // declared they offer it; this is independent of `matrixSelections`
  // (declared rows may have zero project-type cells set).
  matrixDeclaredCategories: string[];
  matrixSelections: MatrixSelection[];
};

export const initialOnboardingFlowWizardState: OnboardingFlowWizardState = {
  selectedVerticals: [],
  selectedProjectTypes: [],
  applyToAll: "unset",
  specifyMode: "unset",
  matrixDeclaredCategories: [],
  matrixSelections: [],
};

// Discriminated union of reducer actions. Names are imperative-mood; one case
// per action in onboardingFlowWizardReducer.
export type OnboardingFlowWizardAction =
  | { type: "toggleVertical"; categoryId: string }
  | { type: "toggleProjectType"; projectType: ProjectType }
  | { type: "setApplyToAll"; value: "yes" | "no" }
  | { type: "setSpecifyMode"; value: "now" | "later" }
  | { type: "toggleMatrixCell"; categoryId: string; projectType: ProjectType }
  | {
      // Bulk-set every (categoryId, projectType) pair for `categoryIds` in a
      // single `projectType` column. Used by the matrix prefill to seed
      // selectedVerticals + descendants × selectedProjectTypes — the
      // runtime cell interaction is binary and never invokes this.
      type: "setMatrixCellsForCategoriesAndType";
      categoryIds: string[];
      projectType: ProjectType;
      checked: boolean;
    }
  // Matrix-stage row toggle. Undeclaring a row also clears any
  // matrixSelections for that exact categoryId — no descendant cascade.
  | { type: "toggleMatrixDeclaredCategory"; categoryId: string }
  // Bulk replace declared-row set. Used by the matrix prefill to seed
  // selectedVerticals + descendants as declared on first mount.
  | { type: "setMatrixDeclaredCategories"; categoryIds: string[] }
  | { type: "reset" };

// Discriminant for which path the user took through the wizard to arrive at
// the setOrganisationOfferedServices mutation — drives the path → payload
// mapping in selectOfferedServicesPayload.
export type OfferedServicesCommitPath =
  | "skip-project-types"
  | "apply-to-all-yes"
  | "specify-later"
  | "specify-now-commit"
  | "skip-matrix";

export type OfferedServicesPayload = {
  categories: string[];
  services: { categoryId: string; projectType: ProjectType }[];
};
